import angular from 'angular';
import routers from './routers.js';
import businessGuidelinesListCtrl from './businessGuidelinesListCtrl.js';
import tableQueryConfig from './tableQueryConfig';

export default angular
  .module('declaration.corporateIncomeTax.businessGuidelines', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config);
      });
    },
  ])
  .controller('businessGuidelinesListCtrl', businessGuidelinesListCtrl)
  .value('tableQueryConfigBG', tableQueryConfig).name;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/businessGuidelines/index.js